export var not = function not(value) {
  return !value;
};